const snackBarToggle = visible => {
  return {
    type: 'SNACKBAR_DISPLAY',
    payload: { visible }
  }
}

const updateSnackBarCopy = copy => {
  return {
    type: 'SNACKBAR_COPY',
    payload: { copy }
  }
}

const updateCurrentPage = pageName => {
  return {
    type: 'UPDATE_CURRENT_PAGE',
    payload: { pageName }
  }
}

const toggleSnackBar = visible => {
  return dispatch => {
    dispatch(snackBarToggle(visible))
  }
}

const setSnackBarCopy = copy => {
  return dispatch => {
    dispatch(updateSnackBarCopy(copy))
  }
}

const setCurrentPage = pageName => {
  return dispatch => {
    dispatch(updateCurrentPage(pageName))
  }
}

const screenSize = screenType => {
  return {
    type: 'SCREEN_TYPE',
    payload: { screenType }
  }
}

const getScreenSize = () => {
  return dispatch => {
    const width = window.outerWidth
    if (width < 800) {
      dispatch(screenSize('mobile'))
    } else {
      dispatch(screenSize('desktop'))
    }
  }
}

export { toggleSnackBar, setSnackBarCopy, setCurrentPage, getScreenSize }
